// Actions
export const EXPENSE_FETCH  = '[Expense] Fetch'

// Mutations
export const EXPENSE_META   = '[Expense] meta'
export const EXPENSE_OBTAIN = '[Expense] obtain'
export const EXPENSE_CLEAR  = '[Expense] clear'
export const EXPENSE_SET_LOADING = '[Expense] set loading'
